export default __webpack_public_path__ + "static/vestibular-ba7933b3a9380748a461ca63e355d8c3.png";